export const paginate = ({ page, pageSize, array }) => {
    const clonedArray = structuredClone(array);
    const start = page * pageSize;
    const end = start + pageSize;
    const portion = clonedArray.slice(start, end);
    return portion;
};
